import request from "@utils/request";

// /**
//  * 首页
//  * @returns {*}
//  */
// export function getHomeData() {
//   return request.get("index", {}, { login: true });
// }

// /**
//  * 发送文本或表情
//  * @param
//  */
// export function kefu_api_text(data) {
//   return request.post("/kefu/api/text", data, { login: true });
// }
/**
 * 申请提现
 * @param
 */
export function pay_withdraw(data) {
  return request.post("/pay/us/withdrawal_record", data, { login: true });
}

export function bank_list(data) {
  return request.post("/pay/bank/list?page=" + data.page, data, {
    login: true
  });
}

